
import CardWrapper from '../../../components/wrapper/card';
import React from 'react';
import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@mui/material';
import {
  Link as LinkIcon,
  VideoCall as VideoCallIcon
} from '@mui/icons-material';

export interface CalendarEventObject {
  id: number;
  event_name: string;
  user_id: number;
  start_date: string | null;
  end_date: string | null;
  set_date: string | null;
  set_time: string | null;
  duration: string;
  platform: string;
  description: string;
  color_tag: 'danger' | 'warning' | 'success' | 'primary';
  type: 'link' | 'meeting';
  event_id: number;
  meeting_link: string;
  calendar_link_id: number | null;
  integration_type: 'google' | 'outlook';
  status: 'active' | 'inactive';
  created_by: number;
  created_at: string;
  updated_at: string;
  unique_id?: string;
  form_json: string;
  meeting_attendees: {
    id: number;
    calendar_meeting_details_id: number;
    email: string;
    status: 'active' | 'inactive';
    created_at: string;
    updated_at: string;
  }[];
}

interface RecentMeetingsProps {
  meetings: CalendarEventObject[];
  maxHeight?: string;
}

const RecentMeetings: React.FC<RecentMeetingsProps> = ({ meetings, maxHeight = '400px' }) => {
  const formatDateTime = (date: string | null, time: string | null) => {
    if (!date) return 'No date set';
    const dateObj = new Date(date);
    const dateStr = dateObj.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
    if (time) {
      return `${dateStr} at ${time}`;
    }
    return dateStr;
  };

  return (
    <CardWrapper >
      <Typography variant="h6" gutterBottom fontWeight="bold">
        Recent Meetings
      </Typography>

      <Box sx={{ maxHeight, overflowY: 'auto', overflowX: 'hidden' }}>
        {meetings?.length === 0
          ? (
            <Box display="flex" alignItems="center" justifyContent="center" height="200px">
              <Typography variant="body2" color="text.secondary">
                No recent meetings found
              </Typography>
            </Box>
          )
          : (
            <List sx={{ width: '100%' }}>
              {meetings?.map((meeting) => (
                <ListItem key={meeting.id} alignItems="flex-start" sx={{ px: 0 }}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'lightgray' }}>
                      {meeting.type === 'meeting' ? <VideoCallIcon /> : <LinkIcon />}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle2" fontWeight="bold">
                        {meeting.event_name}
                      </Typography>
                    }
                    secondary={
                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          {formatDateTime(meeting.set_date, meeting.set_time)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Platform: {meeting.platform}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
      </Box>
    </CardWrapper>
  );
};

export default RecentMeetings;
